<template>
  <el-container class="manage-page">
    <admin-header/>
    <el-main>
      <el-container class="manage-container">
        <el-aside class="left-aside">
          <el-scrollbar class="scrollbar-wrapper">
            <menu-container/>
          </el-scrollbar>
        </el-aside>
        <el-scrollbar ref="rightContainer" class="scrollBar">
          <el-main class="right-container">
            <breadcrumb/>
            <el-card shadow="never">
              <router-view/>
            </el-card>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
  import adminHeader from './components/adminHeader';
  import menuContainer from './components/menuContainer';
  import breadcrumb from './components/breadcrumb';
  import eventBus from '@/plugins/eventBus';

  export default {
    name: 'adminWwwBase',
    mixins: [],
    props: {},
    model: {},
    components: {
      adminHeader,
      menuContainer,
      breadcrumb
    },
    data () {
      return {};
    },
    computed: {},
    methods: {
      onSlideChange (item) {
        let { rightContainer } = this.$refs;
        rightContainer.scrollTop = 0;
      }
    },
    watch: {},
    created () {
    },
    mounted () {
      eventBus.$on('onSlideChange', this.onSlideChange);
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    }
  };
</script>

<style lang="less" scoped>
.manage-page {
  height: 100vh;
  display: flex;
  flex-direction: column;

  > .el-main {
    padding: 0;
    height: auto;
    flex-basis: 0;
  }
}

.manage-container {
  width: 1200px;
  height: 100%;
  margin: auto;
  padding: 0;
}

.scrollBar {
  height: 100%;
  flex: 1;
}

.right-container {
  padding-top: 0;
  position: relative;
  z-index: 0;
}

.left-aside {
  width: 250px;
  height: 100%;
  background: #fff;
  border-right: 1px solid @border-basic;

  /deep/ .scrollbar-wrapper {
    height: 100%;
  }
}
</style>
